import Lenis from 'lenis'

let lenisInstance = null;

export const initLenis = (options) => {
  if (!lenisInstance) {
    lenisInstance = new Lenis();
  }
  return lenisInstance;
};

export const getLenis = () => {
  if (!lenisInstance) {
    throw new Error('Lenis is not initialized');
  }
  return lenisInstance;
};
